{
  "features": {
    "config": {
      "title": "Acompañante del Cordero",
      "subtitle": "Configuración de la integración en Twitch",
      "sections": {
        "premiumSkins": {
          "title": "Atuendos prémium",
          "description": "Con esta extensión, tus espectadores aparecerán en el juego como adeptos. Podrán personalizar a sus adeptos, incluso usar bits para obtener atuendos prémium. Selecciona la cantidad de bits que quieres cobrar por estos atuendos prémium. También puedes dejarlos gratis para que cualquiera los use.",
          "noBitsOption": "No se necesitan bits para atuendos prémium",
          "bitsFeatureNotAvailable": "Tu canal no emplea bits. Tus espectadores podrán seleccionar cualquier atuendo sin gastar bits."
        }
      },
      "actions": {
        "save": "Guardar los cambios"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "¡Unirse a la secta de {{channelName}}",
        "subtitle": "¡Has ganado el sorteo!",
        "timeRemaining": "Tiempo restante: {{time}}",
        "message": "Nuestra secta tiene muchas ventajas: puedes conseguir apéndices demoníacos extra, dedicar cada segundo de vida a la Secta del Cordero... ¡incluso el honor de ser sacrificado!",
        "viewerLinkCta": "Para acceder, {comparte tu identidad}.",
        "actions": {
          "joinRaffle": "Quiero unirme a la secta",
          "joinRaffleViewerHasAlreadyJoined": "¡Has entrado en el sorteo!",
          "dismissRaffle": "No gracias, paso",
          "dismissRaffleViewerHasAlreadyJoined": "Cerrar"
        },
        "raffleJoinedMessage": "Agradecemos tu buena disposición. Si te eligen para unirte a la secta, pronto te enterarás. Puedes cerrar esta ventana."
      },
      "followerBuilder": {
        "title": "Crea a tu adepto",
        "steps": {
          "intro": {
            "message": "¡Te has unido a la secta! El adepto que crees aquí aparecerá en el juego. Ten en cuenta que acabará muriendo, pero será por una buena causa.",
            "actions": {
              "goToNextStep": "Crea a tu adepto"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "Continuar"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "Volver a atuendos",
              "goToNextStep": {
                "variationsForSkin": "Continuar",
                "noVariationsForSkin": "Crear a mi adepto"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "Volver a colores",
              "goToNextStep": "Crear a mi adepto"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "ayudar",
      "hinder": "entorpecer",
      "hhVotingFlyout": {
        "title": "Ayudar o entorpecer",
        "message": "Emite tu voto",
        "timeRemaining": "Tiempo restante: {{time}}",
        "voteCount": "{{amount}} votos"
      },
      "outcomeVotingFlyout": {
        "title": "Emite tu voto por {{helpOrHinder}} a {{channelName}}",
        "timeRemaining": "Tiempo restante: {{time}}"
      }
    }
  }
}
